import { Injectable } from '@angular/core';
import { CommonHttpService } from './common-http.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private commonHttpService: CommonHttpService) { }

  login(data: any) {
    return this.commonHttpService.post(`/auth/login`, data);
  }
  forgotPassword(data: any) {
    return this.commonHttpService.post(`/auth/forgot-password`, data);
  }
  resetPassword(data: any) {
    return this.commonHttpService.put(`/auth/reset-password`, data);
  }
  changePassword(data: any) {
    return this.commonHttpService.put(`/auth/change-password`, data);
  }
  logout(data: any) {
    return this.commonHttpService.post(`/admin/logout`, data);
  }

  saveSessionInLocal(payload) {
    console.log(payload);
    this.saveInLocal('authToken', payload.token);
    this.saveInLocal('email', payload.email);
    this.saveInLocal('name', payload.name);
  }

  removeSessionFromLocal() {
    this.removeFromLocal('authToken');
    this.removeFromLocal('email');
    this.removeFromLocal('name');
  }

  getFromLocal(key: string): string {
    return localStorage.getItem(key);
  }

  saveInLocal(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  removeFromLocal(key: string) {
    localStorage.removeItem(key);
  }
}
